// extracted by mini-css-extract-plugin
export default {"loadingPage":"LoadingPage_loadingPage__cvcOQ","fadeInScale":"LoadingPage_fadeInScale__R-d3Q","exiting":"LoadingPage_exiting__Im7wz","fadeOutScale":"LoadingPage_fadeOutScale__MvS5w"};